module.exports = __webpack_public_path__ + "img/logo.ed0ce74.png";